import { FC } from 'react';
import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';
import { Tooltip, useTooltip } from '@kizen/kds/Tooltip';
import { Typography } from '@kizen/kds/Typography';
import { ClipboardButton } from 'ts-components/ClipboardButton';
import { getStepIdPreview } from 'pages/AutomationEngine/Engine/utilities';

const Row = styled.div`
  flex-shrink: 0;
  display: flex;
  align-items: center;
  gap: 4px;
  min-width: 0;
  height: 32px;
  padding: 0 15px;
`;

export const StepIdLabel: FC<{ stepId: string }> = ({ stepId }) => {
  const { t } = useTranslation();
  const { triggerProps, targetProps, showTooltip, tooltipProps } =
    useTooltip(true);

  const stepIdPreview = getStepIdPreview(stepId);
  if (!stepIdPreview) return null;

  return (
    <Row data-qa-id="code-step-ai-step-id">
      <span {...triggerProps} {...targetProps}>
        <Typography size="sm" color="font-placeholder">
          {t('Step {{ stepIdPreview }}', { stepIdPreview })}
        </Typography>
        {showTooltip ? (
          <Tooltip
            position="bottom"
            text={t('Step ID: {{ stepId }}', { stepId })}
            {...tooltipProps}
          />
        ) : null}
      </span>
      <ClipboardButton value={stepId} />
    </Row>
  );
};
